const pageNameKey = "otaConfigurationBackupDrawerModal";

export const otaConfigurationBackupDrawerModalEn = {
  [pageNameKey]: {
    createConfigurationBackupText: "Create Configuration Backup",
    backupDetailsText: "Backup Details",
    createBackupText: "Create Backup",
    cancelText: "Cancel",
    fixValidateFieldText: "Please fix following fields: ",
    firmwareVersionText: "Firmware Version",
    backupNameText: "Backup Name",
    backupNotesText: "Backup Notes",
    namePlaceholderText: "Choose precise name",
    notesPlaceholderText:
      "What is unique for this backup and valuable to know by others in the future?",
    configurationVersionText: "Configuration Version",
    successMsg: "Configuration backup created successfully",
    errorMsg: "Something went wrong while creating backup.",
    failedToCreateBackup: "Failed to create backup",
  },
};

export const otaConfigurationBackupDrawerModalPtBr = {
  [pageNameKey]: {
    createConfigurationBackupText: "Criar backup da configuração",
    backupDetailsText: "Detalhes do backup",
    createBackupText: "Criar backup",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrija os seguintes campos: ",
    firmwareVersionText: "Versão do firmware",
    backupNameText: "Nome do backup",
    backupNotesText: "Notas de backup",
    namePlaceholderText: "Escolha um nome preciso",
    notesPlaceholderText:
      "O que há de particular neste backup que seria importante para outras pessoas saberem no futuro?",
    configurationVersionText: "Versão da configuração",
    successMsg: "Backup da configuração criado com sucesso",
    errorMsg: "Algo deu errado ao criar o backup.",
    failedToCreateBackup: "Falha ao criar backup",
  },
};

export const otaConfigurationBackupDrawerModalDe = {
  [pageNameKey]: {
    createConfigurationBackupText: "Erstellen Sie eine Konfigurationssicherung",
    backupDetailsText: "Sicherungsdetails",
    createBackupText: "Backup erstellen",
    cancelText: "Stornieren",
    fixValidateFieldText: "Bitte korrigieren Sie die folgenden Felder:",
    firmwareVersionText: "Firmware-Version",
    backupNameText: "Sicherungsname",
    backupNotesText: "Sicherungsnotizen",
    namePlaceholderText: "Wählen Sie einen genauen Namen",
    notesPlaceholderText:
      "Was ist das Besondere an diesem Backup und was ist für andere in Zukunft wertvoll zu wissen?",
    configurationVersionText: "Konfigurationsversion",
    successMsg: "Konfigurations-Backup erfolgreich erstellt",
    errorMsg: "Beim Erstellen des Backups ist ein Fehler aufgetreten.",
    failedToCreateBackup: "Backup konnte nicht erstellt werden",
  },
};

export const otaConfigurationBackupDrawerModalZhHans = {
  [pageNameKey]: {
    createConfigurationBackupText: "创建配置备份",
    backupDetailsText: "备份详情",
    createBackupText: "创建备份",
    cancelText: "取消",
    fixValidateFieldText: "请修改以下字段：",
    firmwareVersionText: "固件版本",
    backupNameText: "备份名称",
    backupNotesText: "备份笔记",
    namePlaceholderText: "选择准确的名称",
    notesPlaceholderText:
      "此备份有哪些独特之处，对未来其他人来说有哪些值得了解的地方？",
    configurationVersionText: "配置版本",
    successMsg: "配置备份创建成功",
    errorMsg: "创建备份时发生错误。",
    failedToCreateBackup: "创建备份失败",
  },
};

export const otaConfigurationBackupDrawerModalIt = {
  [pageNameKey]: {
    createConfigurationBackupText: "Crea backup della configurazione",
    backupDetailsText: "Dettagli di backup",
    createBackupText: "Crea backup",
    cancelText: "Annulla",
    fixValidateFieldText: "Correggi i seguenti campi: ",
    firmwareVersionText: "Versione del firmware",
    backupNameText: "Nome del backup",
    backupNotesText: "Note di backup",
    namePlaceholderText: "Scegli un nome",
    notesPlaceholderText:
      "Cosa contraddistingue questo backup ed è utile per gli altri utenti da sapere?",
    configurationVersionText: "Versione della configurazione",
    successMsg: "Copia di backup della configurazione creata con successo",
    errorMsg: "C'è stato un problema durante la creazione del backup.",
    failedToCreateBackup: "Impossibile creare il backup",
  },
};

export const otaConfigurationBackupDrawerModalEs = {
  [pageNameKey]: {
    createConfigurationBackupText:
      "Crear copia de seguridad de la configuración",
    backupDetailsText: "Detalles de la copia de seguridad",
    createBackupText: "Crear copia de seguridad",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrige los siguientes campos: ",
    firmwareVersionText: "Versión del firmware",
    backupNameText: "Nombre de la copia de seguridad",
    backupNotesText: "Notas de respaldo",
    namePlaceholderText: "Elige un nombre preciso",
    notesPlaceholderText:
      "¿Qué es único de esta copia de seguridad y valioso que otros sepan en el futuro?",
    configurationVersionText: "Versión de configuración",
    successMsg: "Copia de seguridad de la configuración creada correctamente",
    errorMsg: "Se produjo un error al crear la copia de seguridad.",
    failedToCreateBackup: "No se pudo crear la copia de seguridad",
  },
};

export const otaConfigurationBackupDrawerModalNl = {
  [pageNameKey]: {
    backupDetailsText: "Back-updetails",
    backupNameText: "Back-upnaam",
    backupNotesText: "Back-upnotities",
    cancelText: "Annuleren",
    configurationVersionText: "Configuratieversie",
    createBackupText: "Back-up maken",
    createConfigurationBackupText: "Configuratieback-up maken",
    errorMsg: "Er is iets misgegaan bij het maken van de back-up.",
    failedToCreateBackup: "Back-up kon niet worden aangemaakt",
    firmwareVersionText: "Firmwareversie",
    fixValidateFieldText: "Corrigeer de volgende velden: ",
    namePlaceholderText: "Kies een duidelijke naam",
    notesPlaceholderText:
      "Wat is bijzonder aan deze back-up en wat is nuttig voor anderen om in de toekomst te weten?",
    successMsg: "Configuratieback-up succesvol aangemaakt",
  },
};

export const otaConfigurationBackupDrawerModalTr = {
  [pageNameKey]: {
    backupDetailsText: "Yedekleme Ayrıntıları",
    backupNameText: "Yedekleme Adı",
    backupNotesText: "Yedekleme Notları",
    cancelText: "İptal etmek",
    configurationVersionText: "Yapılandırma Sürümü",
    createBackupText: "Yedekleme Oluştur",
    createConfigurationBackupText: "Yapılandırma Yedeği Oluştur",
    errorMsg: "Yedekleme oluşturulurken bir şeyler ters gitti.",
    failedToCreateBackup: "Yedekleme oluşturulamadı",
    firmwareVersionText: "Donanım Yazılımı Sürümü",
    fixValidateFieldText: "Lütfen aşağıdaki alanları düzeltin:",
    namePlaceholderText: "Tam adı seçin",
    notesPlaceholderText:
      "Bu yedekleme için benzersiz olan ve gelecekte başkaları tarafından bilinmesi değerli olan şey nedir?",
    successMsg: "Yapılandırma yedeklemesi başarıyla oluşturuldu",
  },
};
